import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import BannerImage from "../components/img/dental-banner.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import "../styles/pages.css";
import { FaChevronRight, FaCircleArrowRight } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function Dental () {
  const [activeSection, setActiveSection] = useState("overview");
  const [isFixed, setIsFixed] = useState(false);
  const sectionsRef = {
    overview: useRef(null),
    treatment: useRef(null),
    facilities: useRef(null),
    doctors: useRef(null),
  };
  const sidebarRef = useRef(null);
  const contentRef = useRef(null);
  const footerRef = useRef(null);

  const handleScroll = () => {
    const sections = ["overview", "treatment", "facilities", "doctors"];
    let currentSection = "";
    let setFix = false;
    for (let section of sections) {
      const ref = sectionsRef[section].current;
      const { top, bottom } = ref.getBoundingClientRect();
      const isInView =
        top <= window.innerHeight / 2 && bottom >= window.innerHeight / 2;
      if (top < 85) {
        setFix = true;
      } else {
        setFix = false;
      }
      if (isInView) {
        console.log("top", top, "bottom", bottom, "win", window.innerHeight);
        currentSection = section;
      }
    }
    setIsFixed(setFix);
    setActiveSection(currentSection);
  };

  const scrollToSection = (section) => {
    const sectionElement = sectionsRef[section].current;
    if (sectionElement) {
      const offsetTop = sectionElement.getBoundingClientRect().top + window.scrollY;
      const headerOffset = 100; // Adjust this value to match the height of your fixed header or sidebar
      window.scrollTo({
        top: offsetTop - headerOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    handleScroll(); // Trigger once on load
    window.addEventListener("scroll", handleScroll);
  }, []);

  const [doctors, setDoctors] = useState([]);
  const [error, setError] = useState(null);
  const filteredDoctors = doctors.filter(doctor => doctor.department_name === "Dental, Oral & Maxillofacial Surgery");

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_doctors.php`);
        setDoctors(response.data);
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    };
    fetchDoctors();
  }, []);

  const navigate = useNavigate();
  
  const handleDoctorClick = (doctor) => {
    navigate(`/doctor/${doctor.id}`, { state: { doctor } })
  };

  return (
    <div>

        <Navbar />

        <section className="page-section">
            <div className="section-content">
                <p className='page-heading'>Dental, Oral & Maxillofacial Surgery</p>
                
                <div class="d-none d-md-block"> {/*Visible on desktop, hidden on mobile */}
                    <p className="page-subtitle">
                        Providing Comprehensive Dental Care with Advanced 
                        <br/>
                        Technology and a Patient Centered Approach.
                    </p>
                </div>

                <div class="d-md-none mb-2"> {/* Visible on mobile, hidden on desktop */}
                    <p className="page-subtitle">
                        Providing Comprehensive Dental Care with Advanced Technology and a Patient Centered Approach 
                    </p>
                </div>
                
                <div className="page-box">
                    <div className="box-content">
                        <p>At Caritas Matha Hospital, our Dental Department is dedicated to delivering exceptional dental care through a blend of clinical expertise, state-of-the-art technology, and compassionate patient service. Our team, comprising skilled dentists, maxillofacial surgeons, and specialists, collaborates to address diverse dental and oral health needs.</p>
                    </div>
                    <div className="box-image">
                        <img src={BannerImage}/>
                    </div>
                </div>
            </div>
        </section>
		<section className="dept-section">
			<div
				ref={sidebarRef}
				className={`sidebar-title ${!isFixed ? "fixed" : ""}`}
				>
				{["overview", "treatment", "facilities", "doctors"].map((section) => (
					<p
					key={section}
					className={`title ${activeSection === section ? "active" : ""}`}
					onClick={() => scrollToSection(section)}
					>
					{section.charAt(0).toUpperCase() + section.slice(1)}
					{activeSection === section && (
						<FontAwesomeIcon
						icon={faChevronRight}
						className="chevron-icon"
						/>
					)}
					</p>
				))}
        	</div>
			<div ref={contentRef} className="contents">
				<div ref={sectionsRef.overview} className="overview-content">
					<p className="content-heading">Overview</p>
					{/* Overview content here */}
					<p>At Caritas Matha Hospital, our Dental Department is committed to providing top notch dental care through a combination of expertise, advanced technology and compassionate patient care. Our team consist of Dentists with expertise in the fields of oral and maxillofacial surgery,orthognathic surgery, endodontics ,restorative and esthetic dentistry, pediatric dentistry, orthodontics, dental prosthetics , dental implantology, who work together to address a wide range of dental and oral health needs.</p>

					<p>We adopt a multi-disciplinary approach to dental care, tailoring treatment to meet the unique needs of each patient. Whether you are visiting us for a routine check up, or a cpmplex surgical procedure, we prioritise your comfort and well being every step of the way. This ensures that every individual receives personalized care that addresses not only their immediate concerns but also promotes long term oral health,</p>

					<p>Our goal is  to offer comprehensive dental solutions that enhance your quality  of life and restore your confidence with a healthy beautiful smile.</p>


				</div>
				<div ref={sectionsRef.treatment} className="treatment-content">
					<p className="content-heading">Treatment</p>
					{/* Treatment content here */}

					<p>The dental department at Caritas Matha Hospital offers a wide range of treatments including : </p>

					<ul>
						<li>
							<span className="subtitle">Oral and Maxillofacial Surgeries :</span> we offer diagnosis and treatment of oral and maxillofacial pathologies, trauma care,aesthetic facial surgery,orthognathic surgery. We perform simple extractions as well as complex extractions including third molar and canine impactions, cyst enucleations, salivary stone removal and its related pathology, incisional and excisional biopsy.
						</li>
						<br/>

						<li>
							<span className="subtitle">Pediatric dentistry :</span>  we provide preventive and corrective treatment of all dental and oral related problems.
						</li>
						<br/>

						<li>
							<span className="subtitle">Dental implants :</span> we offer single tooth implants, implant supported hybrid dentures, and overdentures
						</li>
						<br/>

						<li>
							<span className="subtitle">Dentures :</span> we provide various denture options, including full, partial, cast partial, immediate and overdentures according to the patient needs.
						</li>
						<br/>

						<li>
							<span className="subtitle">Cosmetic dental treatments :</span> we provide cosmetic procedures like tooth coloured filling materials, veneers, dental bleaching.
						</li>
						<br/>

						<li>
							<span className="subtitle">Root canal treatment :</span> we perform single visit and multiple visit root canal treatments to save infected or traunatised teeth.
						</li>
						<br/>

						<li>
							<span className="subtitle">Ceramic bridges and crowns :</span> our fixed prosthesis are designed to blend seamlesslywith your natural teeth, providing tooth strength and aesthetic appeal.
						</li>
						<br/>

						<li>
							<span className="subtitle">Orthodontic treatment :</span> we provide proper and timely diagnosis with adequate treatment planning for malaligned teeth, taking into consideration patient age and needs.
						</li>
						<br/>

						<li>
							<span className="subtitle">Tmj pain management :</span> our expert doctors help to accuratelu diagnose and manage tmj pains.
						</li>
						<br/>
					</ul>

				</div>
				<div ref={sectionsRef.facilities} className="facilities-content">
					<p className="content-heading">Facilities</p>
					{/* Facilities content here */}

					<p>
						<span className="subtitle">Emergency dental and facial trauma care : </span> our doctors are always available to provide prompt attention and care for all dental and facial related emergencies,poat trauma care, ensuring that patients receive the care and attention as needed.
					</p>

					<p>
						<span className="subtitle">Sterile environment : </span> our clinic adheres to strict sterilization protocols to maintain a safe and hygienic environment for all procedure.
					</p>

					<p>
						<span className="subtitle">Comfortable treatment rooms : </span> our treatments rooms are designed with patient comfort in mind.
					</p>

					<p>At Caritas Matha Hospital, we are dedicated to delivering exceptional dental care that meets the highest standard of quality and patient satisfaction. Whether you require preventive care , restorative treatments or surgical care, our team of doctors is here to support your journey for optimal health.</p>

				</div>
			
				<div ref={sectionsRef.doctors} className="doctors">
					<p className="content-heading">Doctors</p>

					{error && <p>{error}</p>}
					{filteredDoctors.length > 0 ? (
						<div className='doctorbox-container'>
							{filteredDoctors.map(doctor => (
                      			<div key={doctor.id} className="doctorbox">
									<div className="doctor-box">
										<img src={doctor.image_url} className='doctor-img' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
										<div className='doctor-details'>
											<h4 onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}>{doctor['name']}</h4>
											<p>{doctor['designation']}</p>
											<p>{ doctor.available_time }</p>
											<br/>
											{parseInt(doctor.appointment_enabled) === 1 && (
												<p>
													<a href="https://booking.caritasmathahospital.com/OnlineAppointmentBooking/OnlineAppointmentBooking.aspx" target="_blank" rel="noopener noreferrer" >
														Book An Appointment <FaChevronRight />
													</a>
												</p>
											)}
										</div>
									</div>
									<div className='arrow-section'>
										<FaCircleArrowRight className='right-circle-arrow' onClick={() => handleDoctorClick(doctor)} style={{ cursor: "pointer" }}/>
									</div>
								</div>
							))}
						</div>
					) : (
						!error && <p>No doctors available in this department.</p>
					)}
				</div>
        	</div>
      	</section>
      <Footer ref={footerRef} />
    </div>
  );
}

export default Dental;